import React from "react";
// import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import App from "./App";
import fetchJWT from "./FetchJWT"; 

// ReactDOM.render(<App />, document.getElementById("main"));

const rootElement = document.getElementById("main");
const root = createRoot(rootElement);

async function initializeApp() {
  await fetchJWT(); // Fetch JWT before rendering the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)};

initializeApp().catch((error) => {
  console.error("Error initializing app:", error);
});
